import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { func, arrayOf, shape, string } from 'prop-types'

import PlanItem from './PlanItem'

import * as Style from './PlanSelector.style'

export default function PlanSelector({ plans, onClick, theme }) {
  const { loading } = useSelector(store => store.application)

  const defaultSelectedPlan = plans.findIndex(plan => plan.isDefault)
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedPlan)

  useEffect(() => {
    onClick(plans[selectedIndex])
  }, [])

  function handlePlanItemClick(index) {
    setSelectedIndex(index)
    onClick(plans[index])
  }

  return (
    <Style.PlanSelectorWrapper>
      {plans.map((plan, index) => (
        <PlanItem
          key={plan.id}
          label={plan.title}
          pastSelected={index < selectedIndex}
          selected={index === selectedIndex}
          disabled={loading}
          onClick={() => handlePlanItemClick(index)}
          theme={theme.planSelectorItem}
        />
      ))}
    </Style.PlanSelectorWrapper>
  )
}

PlanSelector.propTypes = {
  plans: arrayOf(shape({})),
  onClick: func,
  theme: shape({
    planSelectorItem: shape({
      span: shape({
        backgroundColor: string,
      }),
    }),
  }),
}

PlanSelector.defaultProps = {
  plans: [],
  onClick: () => {},
  theme: {
    planSelectorItem: {
      span: {
        backgroundColor: '',
      },
    },
  },
}
